import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { InvitePage } from "../features/auth/InvitePage";
import { ResetPasswordPage } from "../features/auth/ResetPasswordPage";
import { SignInPage } from "../features/auth/SignInPage";
import { SignUpPage } from "../features/auth/SignUpPage";
import { BillingPage } from "../features/billing/BillingPage";
import { SettingsPage } from "../features/settings/SettingsPage";
import { StreamDetailPage } from "../features/streams/StreamDetailPage";
import { StreamFormPage } from "../features/streams/StreamFormPage";
import { StreamsPage } from "../features/streams/StreamsPage";
import { VideosPage } from "../features/videos/VideosPage";
import { AppShell } from "./AppShell";
import { GuestOnly, RequireSession, RequireTerms } from "./guards";
import { NotFound } from "./NotFound";
import { SessionProvider } from "./session";
import { WorkspaceProvider } from "./workspace";

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<GuestOnly />}>
            <Route path="/sign-in" element={<SignInPage />} />
            <Route path="/sign-up" element={<SignUpPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Route>

          <Route element={<RequireSession />}>
            <Route element={<RequireTerms />}>
              <Route path="/invite/:id" element={<InvitePage />} />
              <Route element={<WorkspaceProvider><AppShell /></WorkspaceProvider>}>
                <Route index element={<Navigate to="/streams" replace />} />
                <Route path="/streams" element={<StreamsPage />} />
                <Route path="/streams/new" element={<StreamFormPage />} />
                <Route path="/streams/:id" element={<StreamDetailPage />} />
                <Route path="/streams/:id/edit" element={<StreamFormPage />} />
                <Route path="/videos" element={<VideosPage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
}
